// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// react-countup component
import CountUp from "react-countup";

// Material Kit 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function DefaultCounterCard({ color, count, title, description, ...rest }) {
  return (
    <MDBox p={2} textAlign="center" lineHeight={1}>
      <MDTypography variant="h1" color={color} textGradient>
        <CountUp end={count} duration={1} {...rest} />
      </MDTypography>
      {title && (
        <MDTypography variant="h5" mt={2} mb={1}>
          {title}
        </MDTypography>
      )}
      {description && (
        <MDTypography variant="body2" color="text">
          {description}
        </MDTypography>
      )}
    </MDBox>
  );
}

// Setting default props for the DefaultCounterCard
DefaultCounterCard.defaultProps = {
  color: "info",
  description: "",
  title: "",
};

// Typechecking props for the DefaultCounterCard
DefaultCounterCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  count: PropTypes.number.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default DefaultCounterCard;
